const FacultyBusinessSvg = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 35 35" fill="none">
      <path
        d="M8.25 24.4375L3.625 28.97V15.9583H8.25M15.9583 21.6008L13.5379 19.535L11.3333 21.57V9.79167H15.9583M23.6667 19.0417L19.0417 23.6667V3.625H23.6667M27.9988 18.7488L25.2083 15.9583H32.9167V23.6667L30.1571 20.9071L19.0417 31.93L13.6921 27.2742L7.86458 32.9167H3.625L13.5996 23.1425L19.0417 27.7367"
        fill="#5D6977"
      />
    </svg>
  );
};

export default FacultyBusinessSvg;
